<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4>Category Master </h4>
          </div>

          <div class="card-body">
            <form [formGroup]="CategoryMasterForm">
              <div class="cardSearch2">
                <div class="card-header2 form-control2" data-toggle="collapse" href="#collapseExample" (click)="showhideAdd()" role="button"
                aria-expanded="false" aria-controls="collapseExample">
                <header class="panel-heading">
                    <h5 class="panel-title">Add Category(Tap to Expand)</h5>
                </header>
            </div>
            <div *ngIf="IsAddpanelshow" id="collapseExample">
              <div class="card-body2">
              <div class="row">

                <div class="col-md-3">
                  <div class="row">
                    <div class="col-md-12">
                      <button type="submit" class="btn-primary1" (click)="toggle()" >Add Category Name</button>
                  </div>
                </div>
              </div>
              <div class="col-md-9">
                <div class="row" *ngIf="show">
                 
                  <div class="col-md-3">
                     <label>Category Name</label>
                  </div>
                  <div class="col-md-6">
                      <input class="form-control" placeholder="Enter Category Name" maxlength="50" [ngClass]="{ 'is-invalid': submitted && f.AddCategoryName.errors }" formControlName="AddCategoryName">
                      <mat-error
                                            *ngIf="GetFormControls('AddCategoryName').invalid && (GetFormControls('AddCategoryName').dirty || GetFormControls('AddCategoryName').touched)"
                                            class="ValidationError">
                                            <mat-error *ngIf="GetFormControls('AddCategoryName').errors.required">
                                            Category Name is required.
                                            </mat-error>
                                          </mat-error>
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn-primary1" (click)="addcategory()" >Save</button>
                  </div>
                </div>
              </div>
                            </div>
                            <div class="clearfix"></div>
                            <br>
                            <div class="row">
              
                              <div class="col-md-6">
                                <div class="row">
                                  <div class="col-md-4"> <label>Category Name</label></div>
                                  <div class="col-md-7">
                                    <!-- <input class="form-control" maxlength="30" [ngClass]="{ 'is-invalid': submitted && f.GroupName.errors }" formControlName="GroupName"> -->
                                    <p-dropdown [options]="groupList" optionLabel="label" placeholder="--Select--" formControlName="Category"
                                    filter="true" [showClear]="true">
                                  </p-dropdown>
                                  <mat-error
                                  *ngIf="GetFormControls('Category').invalid && (GetFormControls('Category').dirty || GetFormControls('Category').touched)"
                                  class="ValidationError">
                                  <mat-error *ngIf="GetFormControls('Category').errors.required">
                                    Category Name is required.
                                  </mat-error>
                                </mat-error>
                                       </div>
                                       <div class="col-md-1"></div>
                                </div>
                              </div>
              
                              <div class="col-md-6">
                                <div class="row">
                                  <div class="col-md-4"> <label>Employee Name</label></div>
                         
                                    <div class="col-md-8"> 
                                      <p-autoComplete formControlName="EmpName" [suggestions]="requesterList"
                                      (completeMethod)="SearchActiveEmployee($event)" placeholder="search name"
                                      field="EmployeeName" [forceSelection]="true" [minLength]="3" size="37"
                                      (onSelect)="SetEmployeeDetails($event)"  (onClear)="clearAutoComplete('EmpName')"
                                    >
                                  </p-autoComplete>
                                  <mat-error
                                  *ngIf="GetFormControls('EmpName').invalid && (GetFormControls('EmpName').dirty || GetFormControls('EmpName').touched)"
                                  class="ValidationError">
                                  <mat-error *ngIf="GetFormControls('EmpName').errors.required">
                                    Employee Name is required.
                                  </mat-error>
                                </mat-error>
                                 
                                      </div>
              
                                  </div>
                                </div>
                                <div class="clearfix"></div>
                                <br>
                                
                              </div>
             
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-md-4">
                  <!-- <div class="row">
                    <div class="col-md-4"> <label>Status</label></div>
                    <div class="col-md-8">
                      <div class="col-md-8">
                        <input type="checkbox" class="checkbox_size" formControlName="IsActive" />
                      </div>
                    </div>
                  </div> -->
                </div>
               
                <div class="col-md-6">
                  <button type="submit" class="btn-primary1"  (click)="Adddata()">Submit</button>
                  <button  class="btn-primary1" (click)="Export()">Export as Excel</button>
                  <button  class="btn-primary1" (click)="Clear()">Clear</button>
                </div>
                <div class="col-md-2">
                 
                </div>
              </div>
              </div>
            </div>
              </div>
                <div class="clearfix"></div>
                <div class="cardSearch2">
                  <div class="card-header2 form-control2" data-toggle="collapse" href="#collapseSearch" (click)="showhide()" role="button"
                      aria-expanded="false" aria-controls="collapseSearch">
                      <header class="panel-heading">
                          <h5 class="panel-title">Search(Tap to Expand)</h5>
                      </header>
                  </div>
                  <div *ngIf="Ispanelshow" id="collapseSearch">
                      <div class="card-body2">
                          <div class="row">
                              <div class="form-group2 col-md-6">
                                  <label class="required" style="width: 120px;">Employee Name</label>
                                  <p-autoComplete formControlName="CustomerSearch" [suggestions]="requesterList"
                                  (completeMethod)="SearchActiveEmployee($event)" placeholder="Employee Name"
                                  field="EmpName" [forceSelection]="true" [minLength]="3" size="37"
                                  (onSelect)="SetEmployeeDetails($event)"  (onClear)="clearAutoCompleteSearch('CustomerSearch')">
                              </p-autoComplete>
                              </div>
                              <div class="form-group2 col-md-6">
                                  <label class="required">Status</label>
                                  <p-dropdown [options]="statusList" optionLabel="StatusName" placeholder="--Select--" formControlName="StatusSearch"
                                  filter="true" [showClear]="true">
                                </p-dropdown>
                              </div>
                          </div>
                          
                          <div class="clearfix"></div>
                        <div class="row">
        
                          <div class="col-md-12" style="text-align: center;">
                            <button class="btn-primary1" (click)="Exit()">Exit</button>
                            <button class="btn-primary1" (click)="ResetData()">Reset</button>
                            <button type="submit" style="margin-top: 10px;margin-right: 80px;" value="Submit" class="btn-primary1" (click)="GetResult()" >Get Result</button>
                            
        
                          </div>
                          
                        </div>
                      </div>
                  </div>
              </div>
              <div class="clearfix"></div>

              <div class="card p-shadow-5 p-mb-5">
                <div class="table-container" #TABLE>

                  <table mat-table [dataSource]="CategoryDataSource" #table style="width:100% !important">

                    <ng-container matColumnDef="Id">
                      <th mat-header-cell *matHeaderCellDef> Id </th>
                      <td mat-cell *matCellDef="let element" style="cursor:pointer;color:blue; text-decoration: underline;"> {{element.Id}} </td>
                    </ng-container>

                    <ng-container matColumnDef="CategoryId" >
                      <th mat-header-cell *matHeaderCellDef > Category ID </th>
                      <td mat-cell *matCellDef="let element" style="cursor:pointer;color:blue; text-decoration: underline;"> {{element.CategoryId}} </td>
                    </ng-container>
                                
                    <ng-container matColumnDef="CategoryName">
                      <th mat-header-cell *matHeaderCellDef> Category Name </th>
                      <td mat-cell *matCellDef="let element"> {{element.CategoryName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="EmployeeGPN" >
                      <th mat-header-cell *matHeaderCellDef> Employee GPN </th>
                      <td mat-cell *matCellDef="let element" > {{element.EmpGPN}} </td>
                    </ng-container>
        

                    <ng-container matColumnDef="EmployeeName">
                      <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                      <td mat-cell *matCellDef="let element"> {{element.EmpName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="IsActive">
                      <th mat-header-cell *matHeaderCellDef> IsActive </th>
                      <td mat-cell *matCellDef="let element"> {{element.IsActive}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="Status">
                      <th mat-header-cell *matHeaderCellDef> Status </th>
                      <td mat-cell *matCellDef="let element"> {{element.Status}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Edit" >
                      <th mat-header-cell *matHeaderCellDef> Action </th>
                      <td mat-cell *matCellDef="let element;  let j = index;" style="cursor:pointer;color:blue; text-decoration: underline;" (click)="statusupdatedata(element.Id)"> Update Status </td>
                    </ng-container>
          
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                  <mat-paginator  #paginator
          [length]="_global.length"
          [pageIndex]="_global.pageIndex"
          [pageSize]="_global.RecordSize"
          [pageSizeOptions]="[5, 10, 25, 100]"
          (page)="onPaginateChange1($event)"></mat-paginator>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>